import React from 'react';
import EMPTY_STATE from 'images/dashboard-empty-state.jpg';

interface IEmptyStateProps {
  refresh: () => void;
  type: string;
}

const EmptyState: React.FC<IEmptyStateProps> = (props) => {
  const { refresh, type } = props;
  const typeText = type.split('_').join(' ');

  return (
    <div className={'empty-container'}>
      <img src={EMPTY_STATE} />
      <p>It seems you haven’t got anything on consignment {typeText}.</p>
      <div className={'button-refresh'} onClick={refresh}>
        <p>Refresh</p>
      </div>
    </div>
  );
};

export default EmptyState;
